import KeyValueRows from './KeyValueRows';
import OnlineCheck from './OnlineCheck';
import OptionIcon from './OptionIcon';
import RetexTag from './RetexTag';
import Map from './Map';
import Address from './Address';
import StrikedText from './StrikedText';
import OrderPrice from './OrderPrice';
import Loading from './Loader';
import ExchangeDifference from './ExchangeDifference';
const TitleMetaTag = () => {
  return null; // Helmet component to prevent symmetry across customer portal oS creation
};
export {
  KeyValueRows,
  OnlineCheck,
  OptionIcon,
  RetexTag,
  Map,
  StrikedText,
  OrderPrice,
  Address,
  Loading,
  ExchangeDifference,
  TitleMetaTag
};
